<ng-container [ngSwitch]="type">
    <ng-template [ngSwitchCase]="'banner-slider'">
        <ng-container [ngSwitch]="typeSlider">
            <ng-template [ngSwitchCase]="sliderType.Normal">
                <ng-container *ngTemplateOutlet="slider"></ng-container>
            </ng-template>
            <ng-template [ngSwitchCase]="sliderType.BannerMode">
                <ng-container *ngTemplateOutlet="bannerSlider"></ng-container>
            </ng-template>
            <ng-template ngSwitchDefault>
                <ng-container *ngTemplateOutlet="slider"></ng-container>
            </ng-template>
        </ng-container>


    </ng-template>
    <ng-template [ngSwitchCase]="'banner'">
        <ng-container *ngTemplateOutlet="banner"></ng-container>
    </ng-template>
</ng-container>
<ng-template #slider>
    <swiper
        [config]="configSliderNormal"
        class="slider-normal"
        #usefulSwiper
    >
        <div class="swiper-wrapper">
            <ng-template
                ngFor
                [ngForOf]="items"
                let-item
                let-i="index"
            >
                <div
                    class="swiper-slide"
                    (click)="eventRegister(item, i)"
                    [ngSwitch]="item.navigateMode"
                >
                    <div *ngSwitchCase="navigateMode.none">
                        <img
                            src="assets/img/banner-placeHolder.jpg"
                            [lazySrc]="item.imageUrl + '?t=' + item.recordVersion"
                            lazySrcVisible="visible"
                            loading="lazy"
                        >
                    </div>
                    <div
                        *ngSwitchCase="navigateMode.InternalLink"
                        (click)="[navigateToInternalUrl(item.navigateTarget)]"
                    >
                        <img
                            src="assets/img/banner-placeHolder.jpg"
                            [lazySrc]="item.imageUrl + '?t=' + item.recordVersion"
                            lazySrcVisible="visible"
                            loading="lazy"
                        >
                    </div>
                    <div
                        *ngSwitchCase="navigateMode.ExternalLink"
                        (click)="device.openLinkInBrowser(item.navigateTarget)"
                    >
                        <img
                            src="assets/img/banner-placeHolder.jpg"
                            [lazySrc]="item.imageUrl + '?t=' + item.recordVersion"
                            lazySrcVisible="visible"
                            loading="lazy"
                        >
                    </div>
                    <div
                        *ngSwitchCase="navigateMode.Play"
                        (click)="playInSlider(item)"
                    >
                        <img
                            src="assets/img/banner-placeHolder.jpg"
                            [lazySrc]="item.imageUrl + '?t=' + item.recordVersion"
                            lazySrcVisible="visible"
                            loading="lazy"
                        >
                    </div>
                </div>
            </ng-template>
        </div>
        <div
            class="swiper-pagination"
            *ngIf="items.length > 1"
        ></div>
    </swiper>
</ng-template>
<ng-template #banner>
    <ng-container [ngSwitch]="items.actionType">
        <div *ngSwitchCase="navigateMode.BannerNone">
            <div class="box-banner-pic">
                <div
                    class="banner-pic"
                    (click)="eventRegister(items, 0)"
                >
                    <img
                        src="assets/img/banner-placeHolder.jpg"
                        [lazySrc]="items.imageUrlMobile + '?t=' + items.recordVersion"
                        lazySrcVisible="visible"
                        loading="lazy"
                    >
                </div>
            </div>
        </div>
        <div *ngSwitchCase="navigateMode.BannerInternalLink">
            <div class="box-banner-pic">
                <div
                    class="banner-pic"
                    (click)="[eventRegister(items, 0), navigateToInternalUrl(items.actionValue)]"
                >
                    <img
                        src="assets/img/banner-placeHolder.jpg"
                        [lazySrc]="items.imageUrlMobile + '?t=' + items.recordVersion"
                        lazySrcVisible="visible"
                        loading="lazy"
                    >
                </div>
            </div>
        </div>
        <div *ngSwitchCase="navigateMode.BannerExternalLink">
            <div
                class="box-banner-pic"
                (click)="eventRegister(items, 0)"
            >
                <div
                    class="banner-pic"
                    (click)="device.openLinkInBrowser(items.actionValue)"
                >
                    <img
                        src="assets/img/banner-placeHolder.jpg"
                        [lazySrc]="items.imageUrlMobile + '?t=' + items.recordVersion"
                        lazySrcVisible="visible"
                        loading="lazy"
                    >
                </div>
            </div>
        </div>
        <div *ngSwitchCase="navigateMode.Play">
            <div
                class="box-banner-pic"
                (click)="eventRegister(items, 0)"
            >
                <div
                    class="banner-pic"
                    (click)="play()"
                >
                    <img
                        src="assets/img/banner-placeHolder.jpg"
                        [lazySrc]="items.imageUrlMobile"
                        lazySrcVisible="visible"
                        loading="lazy"
                    >
                </div>
            </div>
        </div>
    </ng-container>
</ng-template>
<ng-template #bannerSlider>
    <swiper
        [config]="configBannerSlider"
        class="banner-slider"
        #usefulSwiper
    >
        <div class="swiper-wrapper">
            <ng-template
                ngFor
                [ngForOf]="items"
                let-item
                let-i="index"
            >
                <div
                    class="swiper-slide"
                    (click)="eventRegister(item, i)"
                    [ngSwitch]="item.navigateMode"
                >
                    <div *ngSwitchCase="navigateMode.none">
                        <img
                            src="assets/img/banner-placeHolder.jpg"
                            [lazySrc]="item.imageUrl + '?t=' + item.recordVersion"
                            lazySrcVisible="visible"
                            loading="lazy"
                        >
                    </div>
                    <div
                        *ngSwitchCase="navigateMode.InternalLink"
                        (click)="[navigateToInternalUrl(item.navigateTarget)]"
                    >
                        <img
                            src="assets/img/banner-placeHolder.jpg"
                            [lazySrc]="item.imageUrl + '?t=' + item.recordVersion"
                            lazySrcVisible="visible"
                            loading="lazy"
                        >
                    </div>
                    <div
                        *ngSwitchCase="navigateMode.ExternalLink"
                        (click)="device.openLinkInBrowser(item.navigateTarget)"
                    >
                        <img
                            src="assets/img/banner-placeHolder.jpg"
                            [lazySrc]="item.imageUrl + '?t=' + item.recordVersion"
                            lazySrcVisible="visible"
                            loading="lazy"
                        >
                    </div>
                    <div
                        *ngSwitchCase="navigateMode.Play"
                        (click)="playInSlider(item)"
                    >
                        <img
                            src="assets/img/banner-placeHolder.jpg"
                            [lazySrc]="item.imageUrl + '?t=' + item.recordVersion"
                            lazySrcVisible="visible"
                            loading="lazy"
                        >
                    </div>
                </div>
            </ng-template>
        </div>
    </swiper>
</ng-template>
